import { create } from 'zustand';

export interface ChainEventPayload {
  id?: number;
  blockNumber: number;
  logIndex: number;
  txHash: string;
  contractName: string;
  contractAddress: string;
  eventName: string;
  blockTimestamp?: number;
  sequence?: string;
  slotId?: number;
  relatedAccounts?: string[];
  topics?: string[];
  indexedKeys?: Record<string, unknown>;
  eventData?: Record<string, unknown>;
  derivedData?: Record<string, unknown>;
}

interface EventState {
  events: ChainEventPayload[];
  pushEvent: (event: ChainEventPayload) => void;
  clearEvents: (contractName?: string) => void;
}

const MAX_EVENTS = 200;

export const useEventStore = create<EventState>((set) => ({
  events: [],
  pushEvent: (event) =>
    set((state) => ({
      events: [event, ...state.events].slice(0, MAX_EVENTS),
    })),
  clearEvents: (contractName) =>
    set((state) => ({
      events: contractName
        ? state.events.filter((event) => event.contractName !== contractName)
        : [],
    })),
}));
